export default class AbstractFactory {
  /**
   * @param {object} object
   * @param {object} options
   * @abstract
   */
  create({ object = {}, options = {} }) {}
}
